export const ImagenMensajeStyles = 
{
  'img': {
    width: '70%'
  }
}